import { useAvatar } from '@/hooks/queries';
import { cx } from '@/lib/format';

/** The user — never the ORCA mark (the whale is the brand). The uploaded
 *  photo, or a neutral person placeholder. */
export function UserAvatar({ className, size = 'md' }: { className?: string; size?: 'sm' | 'md' | 'lg' }) {
  const src = useAvatar();
  return (
    <span className={cx('uav', size, !src && 'empty', className)} aria-hidden="true">
      {src
        ? <img src={src} alt="" width={256} height={256} decoding="async" />
        : <svg viewBox="0 0 32 32"><circle cx="16" cy="12.4" r="5.2" /><path d="M6.6 27.2c1.6-4.9 5.2-7.6 9.4-7.6s7.8 2.7 9.4 7.6" /></svg>}
    </span>
  );
}
